


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { SubAreaForm } from '@/models/config'

// Components
import { FormCreateEditSubArea } from '@/components/config'

@Component({
    name: 'ModalCreateEditSubArea',
    components: {
        FormCreateEditSubArea
    }
})
export default class ModalCreateEditSubArea extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) subArea!: SubAreaForm

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear Nueva Sub-Area'
        }
        return 'Editar Sub-Area'
    }
}
